import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormGroup, UntypedFormControl } from "@angular/forms";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { GoodsAvragePurchase } from "src/app/backoffice/inv/models/goods-avrage-purchase.model";
import { Goods, GoodsUnit } from "../../../inv/models/goods.model";
import { PriceListDetail } from "../../models/price-list-detail.model";
import { PriceListHeader } from "../../models/price-list-header.model";
import { SellCustomerGroup } from "../../models/sell-customer-group.model";
import { SellKind } from "../../models/sell-kind.model";

@Component({
  selector: "ngx-price-list-header-form",
  templateUrl: "./price-list-header-form.component.html",
  styleUrls: ["./price-list-header-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceListHeaderFormComponent extends BaseFormComponent<PriceListHeader> {
  erroremessage: string;
  currentSellKind: SellKind;
  currentSellCustomerGroup: SellCustomerGroup;
  @ViewChild("detail") public detail: EditableGridComponent;

  PriceListDetailList: form_control[];
  averagePurchase: any[] = [];
  averagePurchaseId: number = 1;
  GetGoodsAvragePurchase: GoodsAvragePurchase[];
  constructor(selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.onNewdefaultRowTregger = this.onNewdefaultRowTregger.bind(this);
  }
  async ngOnInit() {
    this.selectorService.setDisabledValue("GoodsId", true);
    this.apiName = "PriceListHeader";
    this.label = "اعلامیه قیمت";
    super.ngOnInit();
    this.averagePurchase.push({ Code: 1, Title: "آخرین خرید" });
    this.averagePurchase.push({ Code: 2, Title: "میانگین خرید" });
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    let c = this.getDetailControlModels("PriceListDetailList");
    c.forEach((x) => {
      if (x.name === "GoodsId") x.isMulti = true;
    });
    this.PriceListDetailList = c;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.PriceListDetailList = undefined;
  }
  setdefault() {
    if (this.isNewRow && !this.model.PricelistDate) this.model.PricelistDate = new Date();
    if (!this.model.PriceListDetailList) this.model.PriceListDetailList = [];
    if (this.model.BranchId === undefined) this.model.BranchId = this.accountService.authService.currentBranchId;
    if (this.model.FiscalYearId === undefined) {
      if (this.accountService.authService.currentFiscalYear) this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      else
        this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
          if (x) {
            this.setValue("FiscalYearId", x.Id);
            this.model.FiscalYearId = x.Id;
          }
        });
    }
  }
  onNewdefaultRowTregger(model: PriceListDetail, p: Goods) {
    model.SellKindId = this.formGroup.get("SellKind").value;
    model.CustomerGroupId = this.formGroup.get("SellCustomerGroup").value;
    if (p?.DefaultUnitId) {
      model.GoodsUnitId = p?.DefaultUnitId;
      model.GoodsUnitTitle = p?.DefaultUnitTitle;
      model.GoodsUnitCode = p?.DefaultUnitCode;
    }
    return model;
  }
  onChange($event) {
    if (!this.formGroup?.get("PricelistDate")?.value) return;
    var filters: GridFilter[] = [];
    filters.push({
      Filed: "BranchId",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.accountService.authService.currentBranchId,
      Logic: "and",
    });
    filters.push({
      Filed: "FiscalYearId",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.accountService.authService.currentFiscalYear.Id,
      Logic: "and",
    });
    filters.push({
      Filed: "VoucherDate",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.formGroup?.get("PricelistDate")?.value,
      Logic: "and",
    });
    if (this.formGroup?.get("averagePurchaseId")?.value === 2) {
      this.httpCommonService
        .create("InvVoucherHeader/GetAvragePurchase", filters)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.GetGoodsAvragePurchase = x as GoodsAvragePurchase[];
        });
    } else {
      this.httpCommonService
        .create("InvVoucherHeader/GoodsLastPriceList", filters)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.GetGoodsAvragePurchase = x as GoodsAvragePurchase[];
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }
  setMaxCode() {
    let FiscalYearId: number = this.formGroup?.controls["FiscalYearId"]?.value ?? this.model.FiscalYearId;
    this.httpCommonService
      .get(this.apiName + "/GetMaxCode/" + FiscalYearId + "/")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <PriceListHeader>{};
        if (data) {
          this.model["PricelistNo"] = data as number;
          this.setValue("PricelistNo", data as number);
        }
        this.setdefault();
      });
  }
  addControl() {
    this.setValue("SellCustomerGroup", undefined);
    this.setValue("SellKind", undefined);
    this.setValue("UnitPrice", 0);
    this.setValue("DiscountRate", 0);
    this.setValue("UnitPriceratio", 0);
    this.setValue("CheckAllUnit", false);
    this.setValue("CheckAllDiscount", false);
    this.setValue("averagePurchaseId", this.averagePurchaseId, true);
    this.onChange(undefined);
    if (this.detail) this.detail.setColumnWith();
  }
  checkAllUnitValueChange($event) {
    if (this.model && this.model.PriceListDetailList && this.model.PriceListDetailList.length > 0) {
      this.model.PriceListDetailList.forEach((x) => {
        if (x.State !== RowState.Delete && x.State !== RowState.Detached) x.IsFinal = $event;
      });
    }
  }
  checkAllDiscountValueChange($event) {
    if (this.model && this.model.PriceListDetailList && this.model.PriceListDetailList.length > 0) {
      this.model.PriceListDetailList.forEach((x) => {
        if (x.State !== RowState.Delete && x.State !== RowState.Detached) x.DiscountIsFinal = $event;
      });
    }
  }
  onRowSelectedGroup(event) {
    this.currentSellCustomerGroup = event;
  }
  onRowSelected(event) {
    this.currentSellKind = event;
  }
  valueChanges(event) {
    if (event && event.DefaultUnitId) {
      this.httpCommonService
        .getList("Goods/ReadGoodsUnitLookUp/" + event.Id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (!(x as GoodsUnit[]).some((u) => u.UnitId === event["UnitId"]))
            (x as GoodsUnit[]).push({
              GoodsId: event["Id"],
              UnitId: event["UnitId"],
              Ratio: 1,
              UnitTitle: event["UnitTitle"],
              IsDefault: false,
              Id: 0,
            });
          this.selectorService.setDataList("Goods/ReadGoodsUnitLookUp", x as []);
        });
    }
    this.model.PriceListDetailList.forEach((x) => {
      if (x.GoodsId && !x.UnitPrice) {
        let price = this.GetGoodsAvragePurchase.find((up) => up.GoodsId === x.GoodsId);
        x.UnitPrice = this.formGroup?.get("averagePurchaseId")?.value === 1 ? price.DefaultUnitPrice : price.AvrageUnitPrice;
      }
    });

    if (event?.controls && event?.controls["UnitPrice"] && !event?.controls["UnitPrice"]?.value) {
      if (event.controls["GoodsId"].value) {
        let price = this.GetGoodsAvragePurchase.find((up) => up.GoodsId === event.controls["GoodsId"].value);
        (event as FormGroup).controls["UnitPrice"].setValue(
          this.formGroup?.get("averagePurchaseId")?.value === 1 ? price.DefaultUnitPrice : price.AvrageUnitPrice
        );
      }
    }
  }
  increaseUnitPrice() {
    let UnitPriceratio = this.formGroup.controls["UnitPriceratio"].value;
    if (this.model && this.model.PriceListDetailList && this.model.PriceListDetailList.length > 0) {
      if (this.detail?.selectedRows && this.detail?.selectedRows?.length > 0) {
        this.detail.selectedRows.forEach((sr) => {
          let temp = this.model.PriceListDetailList.find(
            (x) => x.GoodsId === sr.GoodsId && x.State !== RowState.Delete && x.State !== RowState.Detached
          );
          if (temp) {
            if (UnitPriceratio) temp.UnitPrice = temp.UnitPrice + (temp.UnitPrice * Number(UnitPriceratio)) / 100;
          }
        });
      } else this.sts.showDialog("هيچ رديفي انتخاب نشده است", "هشدار");
    }
  }
  replaceUnitPrice() {
    let UnitPrice = this.formGroup.controls["UnitPrice"].value;
    let DiscountRate = this.formGroup.controls["DiscountRate"].value;
    if (this.model && this.model.PriceListDetailList && this.model.PriceListDetailList.length > 0) {
      if (this.detail?.selectedRows && this.detail?.selectedRows?.length > 0) {
        this.detail.selectedRows.forEach((sr) => {
          let temp = this.model.PriceListDetailList.find(
            (x) => x.GoodsId === sr.GoodsId && x.State !== RowState.Delete && x.State !== RowState.Detached
          );
          if (temp) {
            if (UnitPrice) temp.UnitPrice = Number(UnitPrice);
            if (DiscountRate) temp.DiscountRate = Number(DiscountRate);
          }
        });
      } else this.sts.showDialog("هيچ رديفي انتخاب نشده است", "هشدار");
    }
  }
  changeGroup() {
    if (this.model && this.model.PriceListDetailList && this.model.PriceListDetailList.length > 0) {
      if (this.detail?.selectedRows && this.detail?.selectedRows?.length > 0) {
        this.detail.selectedRows.forEach((sr) => {
          let temp = this.model.PriceListDetailList.find(
            (x) => x.GoodsId === sr.GoodsId && x.State !== RowState.Delete && x.State !== RowState.Detached
          );
          if (temp) {
            if (this.currentSellKind) {
              temp.SellKindId = this.currentSellKind.Id;
              temp.SellKindTitle = this.currentSellKind.Title;
            }
            if (this.currentSellCustomerGroup) {
              temp.CustomerGroupId = this.currentSellCustomerGroup.Id;
              temp.CustomerGroupTitle = this.currentSellCustomerGroup.Title;
            }
          }
        });
      } else this.sts.showDialog("هيچ رديفي انتخاب نشده است", "هشدار");
    }
  }
  beforupdate() {
    if (this.model.PriceListDetailList && this.model.PriceListDetailList.length > 0) {
      this.model.PriceListDetailList.forEach((x) => {
        if (!x.PriceListHeaderId) x.PriceListHeaderId = 0;
        if (!x.DiscountRate) x.DiscountRate = 0;
      });
      if (!this.formGroup.controls["PriceListDetailList"])
        this.formGroup.addControl("PriceListDetailList", new UntypedFormControl(this.model.PriceListDetailList));
      else this.formGroup.controls["PriceListDetailList"].setValue(this.model.PriceListDetailList);
      this.formGroup.updateValueAndValidity();
    } else this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
  }
}
